import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import LocalizedLink from "../localized-link/LocalizedLink";
import styles from "./AccountSidebar.module.scss";
import { useAuth } from "../../../context/AuthContext";
import { useLocalizedNavigate } from "../../../hooks/useLocalizedNavigate";

const AccountSidebar = () => {
  const { t } = useTranslation("translation");
  const location = useLocation();
  const { logout } = useAuth();
  const navigate = useLocalizedNavigate();

  const menuItems = [
    {
      label: t("account_details"),
      path: "/auth/info",
    },
    {
      label: t("notifications"),
      path: "/auth/notifications",
    },
    {
      label: t("addresses"),
      path: "/auth/addresses",
    },
    {
      label: t("orders"),
      path: "/orders",
    },
  ];

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <div className={styles.sidebar}>
      <h2 className={styles.title}>{t("my_account")}</h2>
      <nav className={styles.nav}>
        <ul className={styles.menu}>
          {menuItems.map((item) => (
            <li key={item.path}>
              <LocalizedLink
                to={item.path}
                className={`${styles.menuItem} ${
                  location.pathname.includes(item.path) ? styles.active : ""
                }`}
              >
                {item.label}
              </LocalizedLink>
            </li>
          ))}
          <li>
            <button onClick={handleLogout} className={styles.logoutBtn}>
              {t("logout")}
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default AccountSidebar;
